import React from 'react';
import { Badge } from 'react-bootstrap';

const EmisoresListSectorPrimarioRoleColumn = ({ data }) => {
  const { sector_primario_is_productor, sector_primario_is_adquiriente } =
    data ?? {};

  const active = sector_primario_is_adquiriente || sector_primario_is_productor;

  return (
    <Badge variant={active ? 'primary' : 'secondary'}>
      {sector_primario_is_productor && <>productor</>}
      {sector_primario_is_adquiriente && <>adquiriente</>}
    </Badge>
  );
};

const EmisoresListSectorPrimarioProductorColumn = ({ data }) => {
  const { sector_primario_is_productor } = data ?? {};

  return (
    <Badge variant={sector_primario_is_productor ? 'primary' : 'secondary'}>
      {sector_primario_is_productor ? 'SI' : 'NO'}
    </Badge>
  );
};

const EmisoresListSectorPrimarioAdquirienteColumn = ({ data }) => {
  const { sector_primario_is_adquiriente } = data ?? {};

  return (
    <Badge variant={sector_primario_is_adquiriente ? 'primary' : 'secondary'}>
      {sector_primario_is_adquiriente ? 'SI' : 'NO'}
    </Badge>
  );
};

const EmisoresListSectorPrimarioColumn = ({ data }) => {
  const variant = data.sector_primario ? 'primary' : 'secondary';
  const text = data.sector_primario ? 'SI ' : 'NO ';

  return <Badge variant={variant}>{text}</Badge>;
};

export {
  EmisoresListSectorPrimarioColumn,
  EmisoresListSectorPrimarioProductorColumn,
  EmisoresListSectorPrimarioAdquirienteColumn,
  EmisoresListSectorPrimarioRoleColumn,
};
